// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Au6Y","header":"ReportDetails_header__2S_m-","title":"ReportDetails_title__1bQVm","left":"ReportDetails_left__10fgR"};